<div class="intl-tel-input-wrapper">
  <input #phoneInput type="tel" [class]="cssClass">
</div>